import { EditOutlined } from '@ant-design/icons-vue';
import { Button as AButton } from 'ant-design-vue';
export default {
  name: 'KpiNamePopover',
  components: {
    EditOutlined,
    AButton
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    },
    popover: {
      type: Boolean,
      default: true
    }
  },
  emits: ['edit', 'remove'],
  setup(props, {
    emit
  }) {
    const handleEdit = () => {
      emit('edit');
    };
    const handleRemove = () => {
      emit('remove');
    };
    return {
      handleEdit,
      handleRemove
    };
  }
};